import { render, staticRenderFns } from "./AiChatInput.vue?vue&type=template&id=36aa160d&scoped=true&"
import script from "./AiChatInput.vue?vue&type=script&lang=js&"
export * from "./AiChatInput.vue?vue&type=script&lang=js&"
import style0 from "./AiChatInput.vue?vue&type=style&index=0&id=36aa160d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aa160d",
  null
  
)

export default component.exports